import { render } from "./MintMedia.vue?vue&type=template&id=7b488404"
import script from "./MintMedia.vue?vue&type=script&lang=js"
export * from "./MintMedia.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__